import React, { useState } from "react";

// assets
import icon_search from "bodycodi/cmap/app/svg/icon_search.svg";
import removeIcon from "bodycodi/cmap/app/img/remove.png";

// utils
import { isEmpty } from "bodycodi/cmap/app/js/common";

const CommunityPageSearchBar = ({ searchTerm, setSearchTerm }: any) => {
  const [value, setValue] = useState<string>(searchTerm);

  const handleKeyUp = (e: any) => {
    if (isEmpty(value)) {
      setSearchTerm("");
      return;
    }

    if (e.keyCode === 13) {
      setSearchTerm(value);
    }
  };

  return (
    <div className="comunity-search-wrap">
      <div className="comunity-search">
        <img className="search" src={icon_search} />

        <input
          type="text"
          placeholder="회원님 이름으로 검색"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyUp={handleKeyUp}
        />
        {!isEmpty(value) && (
          <img
            className="remove"
            src={removeIcon}
            onClick={() => {
              setValue("");
              setSearchTerm("");
            }}
          />
        )}
      </div>
    </div>
  );
};

export default CommunityPageSearchBar;
